import React, { useMemo } from 'react';
import styles from './GrayBanner.module.css';

// Default banner images
const DEFAULT_BANNERS = [
  '/defaul-banners/default-1.png',
  '/defaul-banners/default-2.png',
  '/defaul-banners/default-3.png',
  '/defaul-banners/default-4.png',
];

// Get a deterministic banner index based on an ID string
const getBannerIndex = (id?: string): number => {
  if (!id) return 0;
  // Simple hash: sum of char codes modulo number of banners
  let hash = 0;
  for (let i = 0; i < id.length; i++) {
    hash += id.charCodeAt(i);
  }
  return hash % DEFAULT_BANNERS.length;
};

interface GrayBannerProps {
  className?: string;
  style?: React.CSSProperties;
  children?: React.ReactNode;
  /** Optional ID used to deterministically select a default banner */
  id?: string;
}

const GrayBanner: React.FC<GrayBannerProps> = ({
  className = '',
  style,
  children,
  id
}) => {
  const bannerImage = useMemo(() => {
    const index = getBannerIndex(id);
    return DEFAULT_BANNERS[index];
  }, [id]);

  return (
    <div
      className={`${styles.grayBanner} ${className}`}
      style={{
        ...style,
        backgroundImage: `url(${bannerImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      {children}
    </div>
  );
};

export default GrayBanner;

